import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { emailTemplatesApi, type EmailTemplate } from '@/api/emailTemplatesApi'
import { useTenant } from '@/providers/TenantProvider'

const KEY = 'email-template-oos-alert'

/** The selected tenant's out-of-specification alert email (z8nrz7eq4h). */
export function useOosEmailTemplate() {
  const { selectedTenantId } = useTenant()
  return useQuery({
    queryKey: [KEY, selectedTenantId] as const,
    queryFn: () => emailTemplatesApi.getOosAlert(),
    enabled: !!selectedTenantId,
  })
}

/** Save the tenant's own template, or go back to the default. */
export function useSaveOosEmailTemplate() {
  const { selectedTenantId } = useTenant()
  const qc = useQueryClient()
  const onSuccess = (data: EmailTemplate) => qc.setQueryData([KEY, selectedTenantId], data)
  const save = useMutation({
    mutationFn: (body: { subject: string; body: string }) => emailTemplatesApi.saveOosAlert(body),
    onSuccess,
  })
  const reset = useMutation({
    mutationFn: () => emailTemplatesApi.resetOosAlert(),
    onSuccess,
  })
  return { save, reset }
}
